import { render, staticRenderFns } from "./ServiceRequestCapture.vue?vue&type=template&id=0bbb4f2e&scoped=true"
import script from "./ServiceRequestCapture.vue?vue&type=script&lang=js"
export * from "./ServiceRequestCapture.vue?vue&type=script&lang=js"
import "./ServiceRequestCapture.vue?vue&type=style&index=0&id=0bbb4f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb4f2e",
  null
  
)

export default component.exports